import React from 'react'
import Link from 'next/link'
import { Logo } from '@/components/Logo/Logo'

export type LogoBlockProps = {
  showAsLink?: boolean
  linkUrl?: string
  loading?: 'lazy' | 'eager'
  priority?: 'auto' | 'high' | 'low'
  alignment?: 'left' | 'center' | 'right'
  blockType: 'logo'
}

export const LogoBlock: React.FC<LogoBlockProps> = ({
  showAsLink = true,
  linkUrl = '/',
  loading = 'lazy',
  priority = 'low',
  alignment = 'left',
}) => {
  const alignmentClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  }

  const logoElement = (
    <Logo
      loading={loading}
      priority={priority}
      className="inline-block"
    />
  )

  return (
    <div className={alignmentClasses[alignment]}>
      {showAsLink ? (
        <Link href={linkUrl} className="inline-block">
          {logoElement}
        </Link>
      ) : (
        logoElement
      )}
    </div>
  )
}